"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.View = exports.Feature = exports.OrderByDirection = void 0;
var OrderByDirection;
(function (OrderByDirection) {
    OrderByDirection["asc"] = "asc";
    OrderByDirection["desc"] = "desc";
})(OrderByDirection || (exports.OrderByDirection = OrderByDirection = {}));
var Feature;
(function (Feature) {
    Feature["quoteperm"] = "quoteperm";
    Feature["spell"] = "spell";
    Feature["tcm"] = "tcm";
})(Feature || (exports.Feature = Feature = {}));
var View;
(function (View) {
    View["BondFutOptQuotes"] = "BondFutOptQuotes";
    View["CdsInstruments"] = "CdsInstruments";
    View["CdsQuotes"] = "CdsQuotes";
    View["CmoInstruments"] = "CmoInstruments";
    View["CmoQuotes"] = "CmoQuotes";
    View["CommodityQuotes"] = "CommodityQuotes";
    View["DealsMergersAndAcquisitions"] = "DealsMergersAndAcquisitions";
    View["DerivativeInstruments"] = "DerivativeInstruments";
    View["DerivativeQuotes"] = "DerivativeQuotes";
    View["EquityDerivativeInstruments"] = "EquityDerivativeInstruments";
    View["EquityDerivativeQuotes"] = "EquityDerivativeQuotes";
    View["EquityInstruments"] = "EquityInstruments";
    View["EquityQuotes"] = "EquityQuotes";
    View["FixedIncomeInstruments"] = "FixedIncomeInstruments";
    View["FixedIncomeQuotes"] = "FixedIncomeQuotes";
    View["FundQuotes"] = "FundQuotes";
    View["GovCorpInstruments"] = "GovCorpInstruments";
    View["GovCorpQuotes"] = "GovCorpQuotes";
    View["IndexInstruments"] = "IndexInstruments";
    View["IndexQuotes"] = "IndexQuotes";
    View["IndicatorQuotes"] = "IndicatorQuotes";
    View["Instruments"] = "Instruments";
    View["IRDQuotes"] = "IRDQuotes";
    View["LoanInstruments"] = "LoanInstruments";
    View["LoanQuotes"] = "LoanQuotes";
    View["MoneyQuotes"] = "MoneyQuotes";
    View["MortgageInstruments"] = "MortgageInstruments";
    View["MortQuotes"] = "MortQuotes";
    View["MunicipalInstruments"] = "MunicipalInstruments";
    View["MunicipalQuotes"] = "MunicipalQuotes";
    View["Organisations"] = "Organisations";
    View["People"] = "People";
    View["PhysicalAssets"] = "PhysicalAssets";
    View["Quotes"] = "Quotes";
    View["QuotesAndSTIRs"] = "QuotesAndSTIRs";
    View["SearchAll"] = "SearchAll";
    View["STIRs"] = "STIRs";
    View["VesselPhysicalAssets"] = "VesselPhysicalAssets";
    View["YieldCurveContQuotes"] = "YieldCurveContQuotes";
})(View || (exports.View = View = {}));
